export const signHistoryV2StaffSelectStyle = {
  control: (styles, { isFocused, menuIsOpen, isDisabled }) => {
    return {
      ...styles,
      backgroundColor: isDisabled ? "#e7e7e7 !important" : "#ffffff !important",
      boxShadow: isFocused || menuIsOpen ? "0 0 0 0.05rem #dcd6f9" : "none",
      border: "1px solid #d1d5db !important",
      fontSize: "13px",
      borderRadius: "8px",
      minHeight: "auto",
      height: "35px",
      fontFamily: '"DM Sans", "Segoe UI", sans-serif'
    };
  },
  indicatorsContainer: (styles) => {
    return {
      ...styles,
      height: "100%"
    };
  },
  menuPortal: (styles) => {
    return {
      ...styles,
      zIndex: 1000
    };
  },
  indicatorContainer: (styles) => {
    return {
      ...styles,
      padding: "0px !important"
    };
  },
  indicatorSeparator: (styles) => {
    return {
      ...styles,
      display: "none"
    };
  },
  dropdownIndicator: (styles) => {
    return {
      ...styles,
      color: "#36214880 !important",
      background: "#c0b4ff !important",
      borderRadius: "7px !important",
      padding: "7px 8px !important",
      height: "100%"
    };
  },
  valueContainer: (styles) => {
    return {
      ...styles,
      display: "flex",
      flexDirection: "row",
      overflowX: "hidden",
      paddingTop: "0px",
      paddingBottom: "0px",
      flexWrap: "nowrap",
      height: "100%"
    };
  },
  placeholder: (styles) => {
    return {
      ...styles,
      color: "#000000a6 !important",
      fontFamily: '"DM Sans", "Segoe UI", sans-serif',
      fontSize: "13px",
      fontWeight: "500"
    };
  },
  singleValue: (styles) => {
    return {
      ...styles,
      color: "#362148 !important",
      fontWeight: "500",
      fontFamily: '"DM Sans", "Segoe UI", sans-serif',
      fontSize: "13px",
    };
  },
  multiValue: (styles) => {
    return {
      ...styles,
      minWidth: "auto",
      background: "#ccc"
    };
  },
  input: (styles) => {
    return {
      ...styles,
      "&:focus": {
        boxShadow: "none !important"
      }
    };
  },
  option: (styles, { isSelected }) => {
    return {
      ...styles,
      color: isSelected ? "#fff !important" : "#000000a6 !important",
      padding: "4px 5px",
      alignItems: "center",
      width: "auto",
      marginBottom: "0px",
      display: "flex",
      lineHeight: "22px",
      backgroundColor: isSelected ? "#b8acf4 !important" : "#fff !important",
      "&:hover": {
        backgroundColor: isSelected ? "#b8acf4 !important" : "#b8acf480 !important"
      },
      fontFamily: '"DM Sans", "Segoe UI", sans-serif',
      fontSize: "13px"
    };
  }
};
